import React from 'react';

import Checkbox from 'component/Layout/Form/Checkbox';

import styles from '../Location.module.scss';
import { ListItem, LocationFilterType } from '../types';

interface ItemProps {
    item: ListItem;
    type: LocationFilterType;
    onSelection: (id: number) => void;
    isSelected: boolean;
}

const Item = ({ item, type, onSelection, isSelected }: ItemProps) => (
    <div className={styles.ListItem} title={item.name}>
        <Checkbox
            input={{
                id: `${type}-${item.id}`,
                value: `${item?.id}`,
            }}
            customClass={{
                Label: styles.ItemLabel,
            }}
            onChange={() => onSelection(item.id)}
            isChecked={isSelected}
            withUXSelection
        >
            <span>{item.name}</span>
        </Checkbox>
    </div>
);

export default Item;
